export const parseTextField = (v = '') => v?.toLowerCase();
